// extracted by mini-css-extract-plugin
module.exports = {"crossStyle":"Qr_crossStyle__3syj5","bodyModal":"Qr_bodyModal__TNvti","subText":"Qr_subText__BDaVq","boxStyle":"Qr_boxStyle__1obDO","MainText":"Qr_MainText__3WMto"};